import React from "react";
import { Box } from "@mui/material";
import {
  MyTimesheetWorktimeSummaryMonthly,
  MyTimesheetWorktimeSummaryWeekly,
} from "my-timesheet/components";
import { Period } from "my-timesheet/types/period";

type MyTimesheetWorktimeSummaryProps = {
  handlePeriodChange: (period: Period) => void;
  periodStart: Date;
  periodEnd: Date;
  period: Period;
  role: string;
  isMobile: boolean;
};

export const MyTimesheetWorktimeSummary = ({
  handlePeriodChange,
  periodStart,
  periodEnd,
  period,
  role,
  isMobile,
}: MyTimesheetWorktimeSummaryProps) => {
  return (
    <Box>
      {period === "month" ? (
        <MyTimesheetWorktimeSummaryMonthly
          periodStart={periodStart}
          periodEnd={periodEnd}
          period={period}
          role={role}
          // @ts-ignore
          handlePeriodChange={handlePeriodChange}
          isMobile={isMobile}
        />
      ) : (
        <MyTimesheetWorktimeSummaryWeekly
          periodStart={periodStart.toISOString()}
          periodEnd={periodEnd.toISOString()}
          period={period}
          role={role}
          handlePeriodChange={handlePeriodChange}
          isMobile={isMobile}
        />
      )}
    </Box>
  );
};

export default MyTimesheetWorktimeSummary;
